// One name per person on the grading and packing floor.
//
// The OPH (Fulfillment Ops) and GPH (Hard Crab Planning) histories are keyed by
// whatever was typed in the name box that day, so "Dan" and "Daniel Smart" ranked
// as two people and Year to Date split one person's numbers across both rows.
// Carman, Oct 13, 2026: "Can we get these combined so it knows who is who?" and
// "I'd like the full first and last name used for each grader and packer."
//
// Full names match TimeClock Plus exactly — that is also the join the packer
// auto-fill uses (lib/takt-autofill.js), so a name here must stay TCP's spelling.
//
// ⚠️ MIRRORED in netlify/functions/lib/floor-names.js for the packing TV
// (packing-board.js). CRA cannot import from outside src/, so the list lives in
// both places. Change one, change the other, or the TV crowns a different name
// than this page.
// Current staff only — this is the pick-list. People who have left stay in
// ALIASES below so their old entries still roll up under one full name.
export const FLOOR_ROSTER = [
  'Ashley Crockett',
  'Brenda Hernandez',
  'Daniel Smart',
  'Hannah Parkinson',
  'Jayla Tucker',
  'Jocelyn Hernandez',
  'Montel Douglas',
  'Robert Taylor',
];

// Short names and nicknames as they were actually typed, lower-cased, no trailing
// period. The first five people are Carman's own list. Aaron, Brenda, Jayla and
// Montel are the only person with that first name on the time clock; Carman
// confirmed those Oct 14, 2026, plus Will = William Fluhart and Telly = Montel
// Douglas. Aaron and William have left: kept here for their history, off the
// pick-list. "Ashley" alone is Ashley Crockett — Ashley Hinman is a different
// person, in customer relations, and never on these sheets.
const ALIASES = {
  hannah: 'Hannah Parkinson',
  dan: 'Daniel Smart',
  daniel: 'Daniel Smart',
  robert: 'Robert Taylor',
  bubbles: 'Robert Taylor',
  joce: 'Jocelyn Hernandez',
  jocelyn: 'Jocelyn Hernandez',
  ash: 'Ashley Crockett',
  ashley: 'Ashley Crockett',
  'ashley c': 'Ashley Crockett',
  aaron: 'Aaron Eckmeyer',
  'aaron eckmeyer': 'Aaron Eckmeyer',
  will: 'William Fluhart',
  william: 'William Fluhart',
  'william fluhart': 'William Fluhart',
  telly: 'Montel Douglas',
  brenda: 'Brenda Hernandez',
  jayla: 'Jayla Tucker',
  montel: 'Montel Douglas',
};
FLOOR_ROSTER.forEach((n) => { ALIASES[n.toLowerCase()] = n; });

const key = (raw) => String(raw || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/\.$/, '');

// The full name for anything typed. A name nobody has mapped comes back trimmed
// and otherwise untouched — never guessed at.
export function canonicalFloorName(raw) {
  return ALIASES[key(raw)] || String(raw || '').trim().replace(/\s+/g, ' ');
}

// True when a name is still a first name or nickname after the lookup — the save
// buttons stop on these so a new short name cannot start a second row.
export function isShortFloorName(raw) {
  const n = canonicalFloorName(raw);
  return !!n && !n.includes(' ');
}

// Past entries, renamed in place. Returns the SAME array when nothing changed so
// loading a clean history does not trigger a save.
export function normalizeTaktHistory(hist) {
  if (!Array.isArray(hist)) return hist;
  let changed = false;
  const out = hist.map((r) => {
    if (!r || typeof r.name !== 'string') return r;
    const n = canonicalFloorName(r.name);
    if (n === r.name) return r;
    changed = true;
    return { ...r, name: n };
  });
  return changed ? out : hist;
}

// Names for the pick-list: current staff only, so people who have left drop off.
export function floorNameOptions() {
  return [...FLOOR_ROSTER].sort((a, b) => a.localeCompare(b));
}
